// assets配下のファイルをimportするコンポーザブル
//  ・v-bindで動的にassetsを読み込むために必要となる
//  ・importする対象が増えると読み込みが遅くなる恐れがあるため、@/assets/icon/配下のファイルのみimportしている
//    SEE: https://github.com/nuxt/nuxt/issues/14766#issuecomment-1397365235

const assets = import.meta.glob('@/assets/icon/**', {
  eager: true,
  import: 'default',
});

export const useAsset = () => {
  const getAssetPath = (path: string): string => {
    return assets['/assets/icon/' + path] as string;
  };

  return { getAssetPath };
};
